module.exports = __webpack_public_path__ + "svg_80x80/fsharp.4f9733.svg";